export { DownloadModal } from "./DownloadModal";
export { ImportModal } from "./ImportModal";
export { NodeModal } from "./NodeModal";
export { LoginModal } from "./LoginModal";
export { JWTModal } from "./JWTModal";
export { SchemaModal } from "./SchemaModal";
export { JQModal } from "./JQModal";
export { TypeModal } from "./TypeModal";

type Modal = "download" | "import" | "node" | "login" | "jwt" | "schema" | "review" | "jq" | "type";

export type { Modal };
